var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-credit-card',{attrs:{"host-field-id":_vm.containerName,"title":'מספר כרטיס',"error-message":_vm.cardNumber.error,"focused":_vm.focused,"empty":_vm.cardNumber.isEmpty}})
}
var staticRenderFns = []

export { render, staticRenderFns }